import {Pipe, PipeTransform} from '@angular/core';
import {RequestsDto} from '../../../Models/Rrhh/Requests/request.interface';

@Pipe({
  name: 'requests',
  standalone: false
})
export class RequestsPipe implements PipeTransform {

  transform(items: RequestsDto[], filter: { pendent: boolean, local?: number, type?: number }): RequestsDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.local) {
      items = items.filter((item) => item.id_local == filter.local);
    }

    if (filter.type) {
      items = items.filter((item) => item.id_tipo == filter.type);
    }

    return items.filter((item) => filter.pendent ? item.id_estado === 0 : item.id_estado === 1);

  }

}
